// ==========================================
// Workflow chip rail (3a / 1d)
// ==========================================
// 34px tall, horizontally scrollable, 3-5 workflows with a "+N" counter for the rest.
// Tap runs with defaults; long-press (400ms) opens parameters instead.
// At the compact density the rail collapses into the input row's palette button.
// ==========================================

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';

import { Workflow } from '../../models/buddy.types';
import { ACCENT_HEX, MIC_HOLD_MS } from '../../models/buddy.constants';

@Component({
  selector: 'app-buddy-chip-rail',
  standalone: false,
  templateUrl: './buddy-chip-rail.component.html',
  styleUrls: ['./buddy-chip-rail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuddyChipRailComponent implements OnDestroy {
  @Input() workflows: readonly Workflow[] = [];
  @Input() overflowCount = 0;

  @Output() runRequested = new EventEmitter<string>();
  @Output() paramsRequested = new EventEmitter<string>();
  @Output() overflowClicked = new EventEmitter<void>();

  private holdTimer: ReturnType<typeof setTimeout> | null = null;
  private didHold = false;

  accentFor(workflow: Workflow): string {
    return ACCENT_HEX[workflow.accent];
  }

  onPressStart(workflow: Workflow): void {
    this.didHold = false;
    this.clearHold();
    this.holdTimer = setTimeout(() => {
      this.didHold = true;
      this.holdTimer = null;
      this.paramsRequested.emit(workflow.id);
    }, MIC_HOLD_MS);
  }

  onPressEnd(workflow: Workflow): void {
    this.clearHold();
    if (!this.didHold) {
      this.runRequested.emit(workflow.id);
    }
    this.didHold = false;
  }

  onPressCancel(): void {
    this.clearHold();
    this.didHold = false;
  }

  trackWorkflow(_: number, workflow: Workflow): string {
    return workflow.id;
  }

  private clearHold(): void {
    if (this.holdTimer !== null) {
      clearTimeout(this.holdTimer);
      this.holdTimer = null;
    }
  }

  ngOnDestroy(): void {
    this.clearHold();
  }
}
